import { render } from "./kycForm.vue?vue&type=template&id=683cc783&scoped=true&lang=html"
import script from "./kycForm.vue?vue&type=script&lang=js"
export * from "./kycForm.vue?vue&type=script&lang=js"

import "./kycForm.vue?vue&type=style&index=0&id=683cc783&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683cc783"]])

export default __exports__